<template>
  <div class="table-page-wrapper">


    <div class="table-wrapper">
      <table-column @search="searchColumn" @refresh="toQuery" @change="changeColumn" :column="columns"
        style="padding-bottom: 10px;">
        <el-button @click="add" type="primary" size="small">新增</el-button>
      </table-column>

      <el-table v-loading="tableLoading" :data="tableData" height="80vh" :header-cell-style="{ background: '#fafafa' }"
        highlight-current-row size="small" class="js-table" style="width: 100%" @sort-change="sortChange">


        <el-table-column v-for="(v, i) in checkColumns" :prop="v.field" :label="v.title" :width="v.width"
          :min-width="v.minWidth" :key="i" align="center" :sortable="
            v.field === 'showSmt' ||
            v.field === 'timeKey' ||
            v.field === 'appBundle' ||
            v.field === 'keyword' ||
            v.field === 'contactPhone' ||
            v.field === 'hit' ||
            v.field === 'winPrice' ||
            v.field === 'auctionPrice' ||
            v.field === 'clkSmt' ||
            v.field === 'expensesAge' ||
            v.field === 'incomeAge' ||
            v.field === 'clkAvg'
          ">
          <template v-slot="scope">
            <div v-if="v.field === 'roleType'">
              <span v-if="scope.row.roleType === 1">运营端</span>
              <span v-if="scope.row.roleType === 2">DSP端</span>
              <span v-if="scope.row.roleType === 3">渠道端</span>
            </div>
            <el-switch v-else-if="v.field === 'roleStatus'" v-model="scope.row.roleStatus" active-color="#13ce66"
              :active-value="1" :inactive-value="0" @change="onChange(scope.row)" />
            <span v-else>{{ scope.row[v.field] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="180">
          <template v-slot="scope" align="center">
            <el-button @click="update(scope.row)" type="success" size="mini">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>

      <m-form @submit="submit" ref="form" :title="type + '编辑'" />

      <el-pagination @size-change="sizeChange" @current-change="currentChange" :total="pagination.total"
        :pager-count="6" :current-page="pagination.pageNum" :page-size="pagination.pageSize" :page-sizes="[10, 30, 60]"
        background layout="total,sizes,prev,pager,next" style="margin-top: 40px;" />
    </div>
  </div>
</template>

<script>
import TableColumn from '@/components/TableColumn'
import SearchDspSelect from '@/components/SearchDspSelect'
import BaseDatePicker from '@/components/BaseDatePicker'
import downExcelMixin from '@/mixins/downExcel'
import initTableMixin from '@/mixins/initTable'
import mForm from './form'
import {
  fetchList,
  updateStatus
} from "@/api/jurisdiction/role/index";

export default {
  name: 'Manage/keyword/appWord',
  components: {
    TableColumn,
    SearchDspSelect,
    BaseDatePicker,
    mForm,
  },
  mixins: [initTableMixin, downExcelMixin],
  data() {
    return {
      columns: [
        { field: 'roleId', title: '序号' },
        { field: 'roleName', title: '角色名' },
        { field: 'createTime', title: '创建时间' },
        { field: 'roleType', title: '所属系统' },
        { field: 'accountNumber', title: '账号数量' },
        { field: 'roleStatus', title: '状态' },
      ],
      type: '',
      tey: false
    }
  },
  created() {

  },
  mounted() {
    this.$nextTick(() => {
      this.init()
    })
  },
  provide() {
    return {
      init: this.init
    }
  },
  methods: {
    // beforeInit() {
    // this.tableUrl = '/sysUserRole/manage/list'
    // return true
    // },
    init() {
      fetchList().then(res => {
        this.tableData = res.data
      })
    },
    changeDate(date) {
      this.tableParams.startTime = date.startTime
      this.tableParams.endTime = date.endTime
    },
    onChange(data) {
      updateStatus({
        roleId: data.roleId,
        roleStatus: data.roleStatus
      })
    },
    add() {
      this.type = '新增角色信息'
      this.$refs.form.show()
    },
    update(row) {
      this.type = '修改角色信息'
      this.$refs.form.show(row)
    },
    sortChange(column, prop, order) {
      if (column.order === 'ascending') {
        this.tableParams.asc = column.prop
        this.tableParams.desc = ''
      } else if (column.order === 'descending') {
        this.tableParams.desc = column.prop
        this.tableParams.asc = ''
      }
      this.init()
    },
    removeBlank(val, name) {
      this.tableParams[name] = val.replace(/^\s+|\s+$/gm, '')
    }
  }
}
</script>

<style scoped lang="scss">
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;

  &>* {
    margin-right: 15px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  &>.el-select,
  &>.el-input {
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  background: #ffffff;

  .table__operation {
    padding-bottom: 10px;
  }
}

.el-table::before {
  height: 0;
}

.el-pagination {
  text-align: right;
}
</style>
